import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { v4 as uuidv4 } from 'uuid';
import { SubscribeRequest } from '../../types/subscriber/request';
import { RootState } from '../../store/config/types';
import { AppActions } from './../../store/config/ActionTypes';
import { ThunkDispatch } from 'redux-thunk';
import { connect, ConnectedProps } from 'react-redux';
import {
  executeSubscribe,
  executeForceSubscriptionPayment,
} from '../../store/action_creators/subscriber.actions';

interface SubscribeProps {
  externalId: string;
  subscriptionTypeId: string;
  mustSubscribe: boolean;
  replaceInstrument: boolean;
}

const mapStateToProps = (state: RootState) => ({
  subscriber: state.subscriber,
});

const mapDispatchToProps = (dispatch: ThunkDispatch<RootState, any, AppActions>) => ({
  executeSubscribe: (subscribeRequest: SubscribeRequest) => dispatch(executeSubscribe(subscribeRequest)),
  executeForceSubscriptionPayment: (userId: string) => dispatch(executeForceSubscriptionPayment(userId)),
});

const connector = connect(mapStateToProps, mapDispatchToProps);
type PropsFromRedux = ConnectedProps<typeof connector>;

type PropsType = SubscribeProps & PropsFromRedux;

function Subscribe({
  externalId,
  subscriptionTypeId,
  mustSubscribe,
  replaceInstrument,
  subscriber,
  executeSubscribe,
  executeForceSubscriptionPayment,
}: PropsType) {
  const navigate = useNavigate();

  //#region Fingerprint

  const isTest =
    window.location.host === 'localhost:3000' ||
    window.location.host === 'plinks.netlify.app' ||
    window.location.host === 'plinks.handsoft.com.uy';
  const environmentId = isTest ? '1snn5n9w' : 'k8vif92e';
  const commerceId = isTest ? '123' : 'visanetuy_px_2048256716';
  const fingerprintId = uuidv4();
  const visaFingerprint = commerceId + fingerprintId;
  let fingerprint = isTest ? 'd1cab7e203194d09972b7fb3d4657fc8' : fingerprintId;

  const loadVisaDeviceFingerprint = (callback: any) => {
    const existingScript = document.getElementById('visaDeviceFingerprint');
    if (!existingScript) {
      const script = document.createElement('script');
      script.src = `https://h.online-metrix.net/fp/tags.js?org_id=${environmentId}&session_id=${visaFingerprint}`;
      script.id = 'visaDeviceFingerprint';
      document.body.appendChild(script);

      script.onload = () => {
        if (callback) callback();
      };
    }

    if (existingScript && callback) callback();
  };

  useEffect(() => {
    loadVisaDeviceFingerprint(() => {});
  });

  //#endregion

  useEffect(() => {
    if (
      replaceInstrument &&
      !subscriber.forcingSubscriptionPayment &&
      !subscriber.forceSubscriptionPaymentSuccess &&
      subscriber.forceSubscriptionPaymentError === null
    ) {
      executeForceSubscriptionPayment(externalId);
    }
    if (
      mustSubscribe &&
      !subscriber.subscribing &&
      !subscriber.subscribeSuccess &&
      subscriber.subscribeErrorMessage === null
    ) {
      if (externalId !== '' && subscriptionTypeId !== '') {
        const request: SubscribeRequest = {
          fingerPrint: fingerprint,
          externalId,
          subscriptionTypeId,
          legalId: 'reLegal',
        };
        executeSubscribe(request);
      }
    }
  }, [
    subscriber.subscribing,
    subscriber.subscribeSuccess,
    subscriber.subscribeErrorMessage,
    executeSubscribe,
    subscriber.forcingSubscriptionPayment,
    subscriber.forceSubscriptionPaymentSuccess,
    subscriber.forceSubscriptionPaymentError,
    executeForceSubscriptionPayment,
    fingerprint,
    externalId,
    subscriptionTypeId,
    mustSubscribe,
    replaceInstrument,
  ]);

  useEffect(() => {
    if (
      !subscriber.subscribing &&
      (subscriber.subscribeSuccess || subscriber.subscribeErrorMessage !== null)
    ) {
      navigate('/result');
    }
  });

  useEffect(() => {
    if (
      !subscriber.forcingSubscriptionPayment &&
      (subscriber.forceSubscriptionPaymentSuccess || subscriber.forceSubscriptionPaymentError !== null)
    ) {
      navigate('/result?renovate=true');
    }
  });

  return <></>;
}

export default connector(Subscribe);
